import * as moment from 'moment';
import * as _ from 'lodash';
import { Component, SimpleChanges, OnInit, AfterViewInit, AfterViewChecked, Input, Output, EventEmitter, ViewChildren, QueryList, ChangeDetectionStrategy, SimpleChange, OnChanges } from '@angular/core';
import { Sector, Booking, Addon, AddonOption, TpProduct, OptionValueEntityInstance, Totals } from '../../../../../../models/booking.model';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { ErrorService } from 'app/shared/services/error.service';
import { BookingService } from 'app/shared/services/booking.service';
import { SectorAddonsService } from 'app/shared/services/sector-addons.service';
import { InitialDataService } from 'app/initial-data.service';
import { TravelProductService } from '../../../../../../services/travel-product.service';
import { CartTotalService } from '../../../../../../services/cart-total.service';

@Component({
    selector: 'gaweb-sector-addons',
    templateUrl: './sector-addons.component.html'
})

export class SectorAddonsComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() booking: Booking;
    @Input() productType: string;
    @Input() bookingGuid: string;
    @Input() processing: boolean;
    @Input() sector: Sector;
    
    selectedAddonProductCode: string;
    addon: Addon;
    firstRequest = true;
    showSectorAddons: boolean;
    form: any;
    addonsToPurchase: Array<Addon>;
    loadingCartTotal: boolean;
    
    constructor(
        private travelPackageService: TravelProductService,
        private bookingsService: BookingService,
        private initialDataService: InitialDataService,
        private localStorageService: LocalStorageService,
        private errorService: ErrorService,
        private sectorAddonsService: SectorAddonsService,
        private cartTotalService: CartTotalService
    ) {
        this.processing = true;
    }

    ngOnInit(): void {
        if (this.booking) {
            this.onBookingBeingSet();
        }
        this.setupInitialAddons();
        this.sectorAddonsService.addonCart.subscribe(addons => this.addonsToPurchase = addons)
        this.sectorAddonsService.loadingCartTotal.subscribe(lct => this.loadingCartTotal = lct)
    }

    ngAfterViewInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    optionSelected(a: Addon) {
        if (!this.loadingCartTotal) {
            this.processing = true;
            this.sectorAddonsService.setLoadingCartTotal(true);
            let hasSelected = false;
            a.AddonOptions.forEach(o => {
                o.Selected = false;
                o.OptionValueEntity.forEach(e => {
                    if(e.Selected){
                        o.Selected = true;
                        hasSelected = true;
                        //o.UsageDate = moment(this.sector.PassengerBoardingDate).format("DD/MM/YYYY hh:mm:SS A").toString();
                        //e.UsageDate = moment(this.sector.PassengerBoardingDate).format("DD/MM/YYYY hh:mm:SS A").toString();

                    }
                })
            });
            if(hasSelected){
                this.addonsToPurchase.push(a);
                this.sectorAddonsService.updateAddonsCart(this.booking, this.addonsToPurchase);
            } else {
                this.addonsToPurchase.splice(this.addonsToPurchase.indexOf(a), 1);
                this.sectorAddonsService.updateAddonsCart(this.booking, this.addonsToPurchase);
                this.sectorAddonsService.setLoadingCartTotal(false);
            }
        }
    }

    setupInitialAddons = () => {
        this.sector.Addons = this.decorateAddons(this.sector.Addons);
    }

    isAllowedSectorAddon(ProductCode: string) {
        return GxConstants.ALLOWED_SECTOR_ADDONS.indexOf(ProductCode) !== -1;
    }

    onBookingBeingSet = () => {
    }

    decorateAddons(addons) {
        const forEachAddon = (addon: Addon) => {

            addon.IconUrl = this.getAddonIcon(addon); // <- to run before we transform Title/Name into safe html
            //this.setUsageDate(addon);
        }

        addons.forEach(forEachAddon);
        return addons;
    }

    setUsageDate(addon){
        addon.AddonOptions.forEach((ao: AddonOption) => {
            ao.UsageDate = this.sector.PassengerBoardingDate;
            ao.OptionValueEntity.forEach((ov: OptionValueEntityInstance) => {
                ov.UsageDate = this.sector.PassengerBoardingDate;
            })
        })
    }

    getAddonIcon(addon) {
        const name = (addon.Title || addon.Name || '');

        if (addon.AddonType === 'MG') {
            return '/Assets/images/my-greyhound.png';
        }
        if (addon.AddonType === 'IN') {
            return '/Assets/images/premium.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('baggage') > -1) {
            return '/Assets/images/baggage.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('bicycle') > -1) {
            return '/Assets/images/surfboards.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('carbon') > -1) {
            return '/Assets/images/tree.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('upgrade') > -1) {
            return '/Assets/images/upgrade.png';
        }
        if (addon.AddonType === 'TP' && name.toLowerCase().indexOf('mask') > -1) {
            return '/Assets/images/facemask.png';
        }
        if (addon.AddonType === 'TB') {
            return '/Assets/images/taxback.png';
        }
        return '';
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/sector/sector-addons-wrapper/sector-addons/sector-addons.component.ts